<template>
  <div :class="[b(),className]"
       :style="styleSizeName">
    <div :ref="id"
         :style="styleChartName"></div>
  </div>
</template>

<script>
import create from "../../create";

export default create({
  name: "rectangle",
  methods: {
    updateChart() {
      let optionData = this.deepClone(this.dataChart);
      if (this.isDataCenter) {
        optionData = this.dataChart.map((_el) => {
          return {
            value: _el[this.mcode],
            name: _el[this.dcode],
          };
        })
      }
      let colorList = [];
      const {
        barColor = []
      } = this.option
      if (barColor && barColor.length) {
        colorList = barColor.map(el => el.color1);
      } else {
        colorList = (this.themeCfg?.barColor || []).map(el => el.color1);
      }
      const option = {
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip(),
        series: {
          type: 'treemap',
          data: optionData,
          label: this.getOptionLabel(),
          levels: [
            {
              color: colorList.length ? colorList : '',
              colorMappingBy: 'value',                //用value来决定颜色
            }
          ],
        }
      };
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    }
  }
});

</script>



